import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "flex justify-between gap-4" }
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center min-h-8 min-w-8 h-8 w-8"
}
const _hoisted_5 = { class: "text-racq-dark-grey text-xl-bold" }
const _hoisted_6 = {
  key: 0,
  class: "text-racq-med-grey text-base richtext"
}
const _hoisted_7 = { key: 1 }

import { Text, RichText, Image, Field } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionPanel',
  props: {
    icon: {},
    title: {},
    description: {},
    greyBg: {},
    ssGreyBg: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col gap-6 px-5 md:px-8 pt-6 pb-8 border-2 rounded border-solid border-racq-white shadow-lg", {
      'bg-racq-anti-flash-white': _ctx.greyBg?.value,
      'bg-racq-neutral-grey border-[1.5px] border-solid rounded-lg shadow-md py-2': _ctx.ssGreyBg?.value,
      'bg-white': !_ctx.greyBg?.value && !_ctx.ssGreyBg?.value,
    }])
  }, [
    (_ctx.title?.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.icon?.value?.src)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_unref(Image), { media: _ctx.icon }, null, 8, ["media"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Text), { field: _ctx.title }, null, 8, ["field"])
              ])
            ]),
            (_ctx.$slots.buttonAction)
              ? _renderSlot(_ctx.$slots, "buttonAction", { key: 0 })
              : _createCommentVNode("", true)
          ]),
          (_ctx.description?.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(RichText), { field: _ctx.description }, null, 8, ["field"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.sectionPanelContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "sectionPanelContent", {}, () => [
            _cache[0] || (_cache[0] = _createTextVNode(" [Named slot for section panel content (sectionPanelContent)] "))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})